<template>
  <div ref="pageTop" class="page-wrapper p-lobby center-md">

    <menu-co></menu-co>

    <div class="pure-g halt-lg padding-md lobby-boxes">
      <div class="lobby-content pure-u-1-1">
        <h2 :class="['icon', 'icon-' + category]">{{ $lang.lobby[category] }}</h2>
        <h3>{{ $lang.lobby.title }}</h3>
        <p>{{ $lang.lobby.text }}</p>
        <div v-touch:tap="moveOn" class="btn green">{{ $lang.lobby.button }}</div>
      </div>
    </div>

  </div>
</template>

<script>
  import Menu from '../../../components/menu/'
  import Context from '../../../assets/data/context.json'
  import dataOptions from '../../../assets/data/staticdata.json'

  export default {
    name: 'case-lobby',
    data () {
      return {
        category: '',
        dataContext: Context,
        dataOptions: dataOptions
      }
    },
    props: ['props'],
    beforeMount () {
      this.category = (
        this.$route.params.cat === this.dataContext.categories[0].cat ||
        this.$route.params.cat === this.dataContext.categories[1].cat)
        ? this.$route.params.cat : this.dataContext.categories[0].cat

      this.store.setItem(this.dataContext.current_context, this.category)
      if (!this.store.getItemOrFalse(this.dataContext.current_progress)) {
        let obj = {}
        obj[this.dataContext.categories[0].cat] = []
        obj[this.dataContext.categories[1].cat] = []
        this.store.createIfNotExisting(this.dataContext.current_progress, obj)
      }
    },
    mounted () {
      this.$nextTick(function () {
        window.scrollTo(0, 0)
      })
    },
    methods: {
      moveOn () {
        this.$router.push({ path: `/case-progress` })
        // TODO: If theuser has done all questions for this category, then redirect to checklist
//        let catCases = this.dataOptions.caselists[this.category]
//        let progress = this.store.getItem(this.dataContext.current_progress)[this.category]
//        let moveTo = this.util.getFirstQuestionForCategoryNotAnswered(catCases, progress)
//        if (!moveTo) {
//          this.$router.push({ path: `/checklist` })
//        } else {
//          this.$router.push({ path: `/case-progress` })
//        }
      },
      categoryItemClicked (cat) {
        this.store.setItem(this.context.current_context, this.context.categories[cat].cat)
        if (!this.store.getItemOrFalse(this.context.current_progress)) {
          let obj = {}
          obj[this.context.categories[0].cat] = []
          obj[this.context.categories[1].cat] = []
          this.store.createIfNotExisting(this.context.current_progress, obj)
        }
      }
    },
    components: {
      'menu-co': Menu
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/content/lobby/index.vue